/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { connect } from "react-redux";
import Modal from "modules/common/components/Modal";
import Select from "react-select";
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from "App";
import PropTypes from "prop-types";
import * as actions from "../action";
import * as c from '../constant';

function AdditionalCostsModal({
  createData,
  type,
  dataInfo,
  updateData,
  getList,
  formData,
  setFormData,
  id,
  applicationId,
  additionalCostList,
  getAdditionalCostList,
}) {
  const setModal = useContext(ModalContext);
  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createData(applicationId, formData, (data) => {
        setModal({ isOpen: false });
        getList(applicationId);
      });
    }

    if (type === 'EDIT') {
      updateData(applicationId, id, formData, (data) => {
        getList();
        setModal({ isOpen: false });
        getList(applicationId);
      });
    }

  };

  const handleOnClose = (e) => {
    if (e) e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getAdditionalCostList();
  }, []);

  useEffect(() => {
    if (type === "EDIT") {
      setFormData({
        ...formData,
        rptax_building_additional_cost_id: _.get(dataInfo, 'rptax_building_additional_cost_id'),
      });
    }
  }, []);

  const additionalCostOptions = additionalCostList.map((x) => {
    return {
      value: x.id,
      label: x.attributes.name,
      fullInfo: x,
    };
  });

  const handleSelected = key => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className='row'>
          <div className='col-12 form-group'>
            <Select
              value={additionalCostOptions.filter(item => +_.get(formData, 'rptax_building_additional_cost_id') === +_.get(item, 'value')) || ''}
              onChange={handleSelected('rptax_building_additional_cost_id')}
              options={additionalCostOptions}
              placeholder="Select Additional Cost."
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>

          {/* <div className='col-12 form-group'>
            {createCheckbox({ key: 'is_active', label: 'Is Active' })}
          </div> */}
        </div>
        <div className='d-flex justify-content-center mt-4'>
          <button type='submit' className='btn btn-md btn-primary cms-bg-color-primary cms-outline-primary  mr-1 bg-color-primary'>
            Submit
          </button>
          <button
            type='button'
            onClick={handleOnClose}
            className='btn btn-light ml-1'
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AdditionalCostsModal.defaultProps = {
  type: '',
  dataInfo: {},
  id: '',
  applicationId: '',
};

AdditionalCostsModal.propTypes = {
  createData: PropTypes.instanceOf(Function).isRequired,
  updateData: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  id: PropTypes.string,
  applicationId: PropTypes.string,
  dataInfo: PropTypes.instanceOf(Object),
  getList: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  additionalCostList: PropTypes.instanceOf(Array).isRequired,
  getAdditionalCostList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  additionalCostList: _.get(api, `${c.GET_ADDITIONAL_COST_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  withForm,
  connect(mapStateToProps, actions),
]);

export default enhance(AdditionalCostsModal);
